import styled from 'styled-components';
export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
  min-width: 200px;
  padding: var(--spacing-02);
  background: var(--layer-01, #ffffff);
  border-radius: var(--border-radius-large, 12px);
  box-shadow: var(
    --shadow-floating,
    0 4px 16px rgba(0, 0, 0, 0.12)
  );
`;
export const OptionButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
  width: 100%;
  margin: 0;
  padding: var(--spacing-03) var(--spacing-04);
  border: none;
  border-radius: var(--border-radius-default, 8px);
  background: ${({ $selected })=>$selected ? 'var(--layer-accent-01, #f4f4f4)' : 'transparent'};
  cursor: pointer;
  text-align: left;

  &:hover {
    background: var(--layer-hover-01, #f4f4f4);
  }
`;
export const OptionLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-02, 14px);
  font-weight: 400;
  line-height: 1.25;
  color: var(--text-secondary, #6f6f6f);
`;
export const CheckIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: var(--interactive-01, #0f62fe);

  svg {
    width: 14px;
    height: 14px;
  }
`;
export const Mark = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  overflow: hidden;
`;
export const MarkImage = styled.img`
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
`;
export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: ${({ $fill })=>$fill ? 'flex-start' : 'center'};
  flex: ${({ $fill })=>$fill ? 1 : undefined};
  min-width: ${({ $fill })=>$fill ? 0 : undefined};
  max-width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;
